export default (function (siteVars) {
    return {
        color: siteVars.white,
        descriptionColor: siteVars.gray02,
    };
});
